<template>
  <popup
    title="ИНСТРУКЦИЯ"

    :value="value"
    :styles="{width: '940px'}"
    @input="$emit('input', $event)"
  >
    <template v-slot:content>
      <vuescroll
        :ops="ops"
        ref="vs"
        class="instruction"
      >
        <p>Сейчас я подключу специалиста приёмной комиссии по выбранным тобой направлениям, он ответит на все вопросы, и расскажет о поступлении. Тебе необходимо перейти по одной из этих ссылок для регистрации и дальнейшего общения с менеджером приемной комиссии Университета Синергия:</p>
        <ul>
          <li>
            <a href="https://api.whatsapp.com/send?phone=79774910129" target="_blank">
              <img src="/images/icons/whatsapp.png">
              <p>Специалист Ильнар</p>
            </a>
          </li>
          <li>
            <a href="https://telegram.im/@synergy_specialist" target="_blank">
              <img src="/images/icons/telegram.png">
              <p>Специалист Ильнар</p>
            </a>
          </li>
          <li>
            <a href="https://api.whatsapp.com/send?phone=79199652202" target="_blank">
              <img src="/images/icons/whatsapp.png">
              <p>Специалист Ирина</p>
            </a>
          </li>
          <li>
            <a href="https://t.me/miraclee77" target="_blank">
              <img src="/images/icons/telegram.png">
              <p>Специалист Анастасия</p>
            </a>
          </li>
          <li>
            <a href="https://api.whatsapp.com/send?phone=79850727578" target="_blank">
              <img src="/images/icons/whatsapp.png">
              <p>Специалист Даниил</p>
            </a>
          </li>
        </ul>
      </vuescroll>
    </template>
    <template v-slot:footer>
      <a
        href="https://synergy.ru/filing_documents/"
        class="btn submit-documents click-sound"
        target="_blank"
      >
        <i class="submit-documents__icon"/>
        Подать документы
      </a>
    </template>
  </popup>
</template>

<script>
  import vuescroll from 'vuescroll'
  import Popup from '@/components/Popup'

  export default {
    props: {
      value: {
        type: Boolean,
        default: false
      }
    },
    data(){
      return {
        ops: {
          vuescroll: {
            detectResize: false
          },
          scrollPanel: {
            scrollingX: false
          },
          rail: {
            size: '13px',
            opacity: '.5',
            specifyBorderRadius: '0px',
            gutterOfEnds: '0px',
            gutterOfSide: '0px',
            background: '#000716'
          },
          bar: {
            size: '13px',
            opacity: '1',
            background: '#000716',
            keepShow: true
          }
        }
      }
    },
    components: {
      vuescroll,
      Popup
    }
  }
</script>

<style lang="scss" scoped>
  .instruction {

    p {
      margin-bottom: 30px;
      font-size: 23px;

      &:last-child {
        margin-bottom: 0;
      }
    }
    ul {
      display: flex;
      flex-wrap: wrap;
      margin-left: -15px;
      margin-right: -15px;

      li {
        width: 50%;
        padding: 0 15px;
        margin-top: 25px;

        &:nth-child(-n+2) {
          margin-top: 0;
        }
        a {
          display: inline-flex;
          align-items: center;

          img {
            display: block;
            width: 70px;
            height: auto;
          }
          p {
            margin-left: 20px;
            font-weight: bold;
          }
        }
      }
    }
  }
  .submit-documents {
    display: inline-flex;
    padding: 25.5px 20px;
    align-items: center;
    justify-content: center;

    &__icon {
      display: block;
      width: 38px;
      height: 34px;
      margin-right: 10px;
      background: url(/images/icons/documents.png) no-repeat;
      background-size: cover;
    }
  }
</style>
